import React from 'react';
import { createRoot } from 'react-dom/client';
import '../tournaments.css';
import '../manifoldlimitmarket.css';
import LimitMarketLayout from '../components/limitmarket/LimitMarketLayout.jsx';
import LimitMarketPage from '../components/limitmarket/LimitMarketPage.jsx';

const root = createRoot(document.getElementById('root'));
root.render(
  <LimitMarketLayout active="marketplace">
    <LimitMarketPage />
  </LimitMarketLayout>
);
